<div class="review__box">
  <p class="review__title">
    {{ title }}
  </p>
  <p class="review__note">
    <span class="note__value">{{ roundedGlobalNote }}</span
    >/5
    <app-vtmn-rating
      class="note__vitamine"
      [value]="roundedGlobalNote"
      [size]="ratingSize"
      [emphasis]="true"
    ></app-vtmn-rating>
  </p>
  <p class="review__total">
    {{ totalReviews }}
  </p>
</div>
